export function createContentfulEntryUrl({
  spaceId,
  environment = "master",
  accessToken,
  entryId,
  locale = "en-US",
}: {
  spaceId: string;
  environment?: string;
  accessToken: string;
  entryId: string;
  locale?: string;
}) {
  return `https://cdn.contentful.com/spaces/${spaceId}/environments/${environment}/entries/${entryId}?access_token=${accessToken}&locale=${locale}`;
}

export function createContentfulAssetUrl({
  spaceId,
  accessToken,
  assetId,
}: {
  spaceId: string;
  accessToken: string;
  assetId: string;
}) {
  return `https://cdn.contentful.com/spaces/${spaceId}/assets/${assetId}?access_token=${accessToken}`;
}
